<template>
    <div class="main">
        <c-panel>
            <detalhe :paramId="$route.params.id"></detalhe>
        </c-panel>
    </div>
</template>
<script>

import detalhe from "./detalhe"

export default {
    components:{ detalhe }
}
</script>
